import { React, useEffect } from "react";
import Button from '@mui/material/Button';
import { Link } from "react-router-dom";
import "./Info.scss"

export const Cookies = () => {
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, []);
    return (
        <div className="info-pages">
            <div className="modal-content-info bg-white shadow">
                <div className="row text-end pe-4 me-3 pt-2">
                    <Link to="/score">
                        <Button className="col position-fixed">
                            <span ><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd" d="M14.7.423a.905.905 0 0 0-1.205.066L7.631 6.353 1.766.49a.903.903 0 0 0-1.277 0L.423.562A.903.903 0 0 0 .49 1.766l5.864 5.865L.49 13.495a.903.903 0 0 0 0 1.278l.073.066a.902.902 0 0 0 1.204-.066l5.865-5.867 5.864 5.867a.903.903 0 0 0 1.278 0l.066-.074a.902.902 0 0 0-.066-1.204L8.907 7.631l5.866-5.864a.902.902 0 0 0 0-1.277l-.074-.065.001-.002z" fill="#5C157D" />
                            </svg></span>
                        </Button>
                    </Link>
                </div>
                <div className="text-legal">

                    <h1 className="mb-4">
                        Política de cookies
                    </h1>
                    <h6 className="text-start">
                        <strong>Política de cookies</strong>
                    </h6>
                    <p className="mb-4">
                        Una <em>cookie </em>es un pequeño fichero de texto que se almacena en su
                        navegador cuando visita casi cualquier página web. Su utilidad es que la
                        web sea capaz de recordar su visita cuando vuelva a navegar por esa página.
                        Las <em>cookies</em> suelen almacenar información de carácter técnico,
                        preferencias personales, personalización de contenidos, estadísticas de
                        uso, enlaces a redes sociales, acceso a cuentas de usuario, etc. El
                        objetivo de la <em>cookie </em>es adaptar el contenido de la web a su
                        perfil y necesidades, sin <em>cookies </em>los servicios ofrecidos por
                        cualquier página se verían mermados notablemente. Si desea consultar más
                        información sobre qué son las <em>cookies</em>, qué almacenan, cómo
                        eliminarlas, desactivarlas, etc.,
                        <span className="ps-1">
                            <a target="_blank" rel="noreferrer" href="https://solunion.com/mas-informacion-las-cookies/">
                                le rogamos se dirija a este enlace.
                            </a>
                        </span>
                    </p>
                    <p className="mb-4">
                        <strong>Cookies utilizadas en este sitio web</strong>
                    </p>
                    <p className="mb-4">
                        Siguiendo las directrices de la Agencia Española de Protección de Datos
                        procedemos a detallar el uso de <em>cookies</em> que hace esta web con el
                        fin de informarle con la máxima exactitud posible.
                    </p>
                    <p className="mb-4">
                        Podrá gestionar la utilización de cookies a través de esta página web
                        mediante nuestro gestor de cookies.
                    </p>
                    <p className="mb-4">
                        <strong>Este sitio web utiliza el siguiente tipo de cookies:</strong>
                    </p>
                    <ul type="disc" className="mb-4">
                        <li>
                            <strong>Cookies técnicas: </strong>
                            son aquellas que permiten al usuario la navegación a través de una
                            página web, plataforma o aplicación y la utilización de las diferentes
                            opciones o servicios que en ella existan, incluyendo aquellas que el
                            editor utiliza para permitir la gestión y operativa de la página web y
                            habilitar sus funciones y servicios.
                        </li>
                    </ul>
                    <ul type="disc" className="mb-4">
                        <li>
                            <strong>Cookies analíticas: </strong>
                            son aquellas que permiten el seguimiento y análisis del comportamiento
                            de los usuarios de los sitios web a los que están vinculadas, incluida
                            la cuantificación de los impactos de los anuncios. La información
                            recogida mediante este tipo de cookies se utiliza en la medición de la
                            actividad de los sitios web, aplicación o plataforma, con el fin de
                            introducir mejoras en función del análisis de los datos de uso que
                            hacen los usuarios del servicio.
                        </li>
                    </ul>
                    <ul type="disc">
                        <li>
                            <strong>Cookies de publicidad comportamental: </strong>
                            son aquellas que almacenan información del comportamiento de los
                            usuarios obtenida a través de la observación continuada de sus hábitos
                            de navegación, lo que permite desarrollar un perfil específico para
                            mostrar publicidad en función del mismo.
                        </li>
                    </ul>
                    <p className="mb-4">
                        <strong>Este sitio web utiliza las siguientes cookies propias:</strong>
                    </p>
                    <ul type="disc" className="mb-4">
                        <li>
                            <strong>Cookies de sesión</strong>
                            , para garantizar que los usuarios que accedan sean humanos y no
                            aplicaciones automatizadas. De esta forma se combate el <em>spam</em>.
                            Esta cookie se utiliza para almacenar e identificar el ID de sesión de
                            un usuario con el propósito de administración la sesión del usuario en
                            el sitio web. Los datos personales no se conservarán más allá del plazo
                            necesario para conseguir el fin para el cual se tratan, salvo en los
                            supuestos previstos legalmente, siendo éste el cierre de todas las
                            ventanas del navegador.
                        </li>
                    </ul>
                    <ul type="disc" className="mb-4">
                        <li>
                            <strong>Cookies de almacenamiento y acceso a la información</strong>
                            : El almacenamiento de información, o el acceso a información que ya
                            está almacenada en su dispositivo, identificadores de dispositivos,
                            cookies y tecnologías similares. Los datos personales no se conservarán
                            más allá del plazo necesario para conseguir el fin para el cual se
                            tratan, salvo en los supuestos previstos legalmente, que
                            identificaremos seguidamente según el tipo de cookie:
                        </li>
                    </ul>
                    <ul type="disc" className="mb-4">
                        <li>
                            En relación a aquellas cookies que se establecen necesariamente por
                            plugin de “Consentimiento” que son usadas para almacenar el
                            consentimiento del usuario, los datos personales se conservarán durante
                            un plazo de 1 año.
                        </li>
                        <li>
                            Respecto a las cookies de almacenamiento establecida por
                            doubleclick.net. Debido a que el propósito de la cookie es determinar
                            si el navegador de los usuarios soporta cookies, el plazo de
                            conservación es de 15 minutos.
                        </li>
                        <li>
                            Google DoubleClick almacena información sobre cómo el usuario utiliza
                            el sitio web y cualquier otro anuncio antes de visitar el sitio web.
                            Esto se utiliza para presentar a los usuarios anuncios que son
                            relevantes para ellos de acuerdo con el perfil del usuario, con un
                            plazo de conservación de 2 años.
                        </li>
                        <li>
                            La cookie usada para crear un perfil basado en el interés del usuario y
                            mostrar anuncios personalizados a los usuarios, cuya información
                            personal será conservada durante 5 meses.
                        </li>
                    </ul>
                    <ul type="disc" className="mb-4">
                        <li>
                            <strong>Envío de contenido</strong>
                            : Sistema de envío de contenido mediante correo electrónico. Esto
                            incluye usar información del contacto previamente recogida. Esta cookie
                            de rastreo permite al sitio web vincular el comportamiento del
                            visitante al destinatario de una campaña de marketing por correo
                            electrónico, para medir la eficacia de la referida campaña. Los datos
                            personales no se conservarán más allá del plazo necesario para
                            conseguir el fin para el cual se tratan, salvo en los supuestos
                            previstos legalmente, siendo éste de 2 años.
                        </li>
                    </ul>

                    <p className="mb-4">
                        <strong>Este sitio web utiliza las siguientes cookies de terceros:</strong>
                    </p>
                    <ul type="disc" className="mb-4">
                        <li>
                            <strong>Google Analytics</strong>
                            : Almacena cookies para poder elaborar estadísticas sobre el tráfico y
                            volumen de visitas de esta web. Al utilizar este sitio web está
                            consintiendo el tratamiento de información acerca de usted por Google.
                            Por tanto, el ejercicio de cualquier derecho en este sentido deberá
                            hacerlo comunicando directamente con Google. Los datos personales no se
                            conservarán más allá del plazo necesario para conseguir el fin para el
                            cual se tratan, salvo en los supuestos previstos legalmente. Dentro de
                            este tipo de cookies, interesa distinguir las que siguen:
                        </li>
                    </ul>
                    <ul type="disc" className="mb-4">
                        <li>
                            Aquella cookie utilizada para calcular los datos de visitantes,
                            sesiones, campañas y para hacer un seguimiento del uso del sitio para
                            el informe analítico del mismo. Éstas almacenan información de forma
                            anónima y asignan un número generado aleatoriamente para identificar a
                            los visitantes únicos, siendo el plazo de conservación 2 años.
                        </li>
                    </ul>
                    <ul type="disc" className="mb-4">
                        <li>
                            Esta cookie es instalada por Google Analytics, y se utiliza para
                            almacenar información de cómo los visitantes utilizan un sitio web y
                            ayuda en la creación de un informe analítico de cómo el sitio web está
                            haciendo. Los datos personales recogidos incluyen el número de
                            visitantes, la fuente de donde vienen y las páginas visitadas de forma
                            anónima y su plazo de conservación es de 1 día.
                        </li>
                    </ul>
                    <ul type="disc" className="mb-4">
                        <li>
                            Respecto a la cookie que usa Google Analytic para distinguir a los
                            usuarios, el plazo de conservación de los datos recogidos es de 1
                            minuto.
                        </li>
                    </ul>
                    <p className="mb-4">
                        Puede obtener más información sobre la política de privacidad en
                        <a className="mb-4 ms-2" target="_blank" rel="noreferrer" href="http://www.google.com/intl/es_ALL/privacypolicy.html">
                            http://www.google.com/intl/es_ALL/privacypolicy.html
                        </a>
                    </p>
                    <ul type="disc" className="mb-4">
                        <li>
                            <strong>Redes sociales</strong>
                            : Cada red social utiliza sus propias cookies para que usted pueda
                            pinchar en botones del tipo Me gusta o Compartir. Las redes sociales
                            son LinkedIn, Instagram y Facebook. Los datos personales no se
                            conservarán más allá del plazo necesario para conseguir el fin para el
                            cual se tratan, puede obtener más información de la política de
                            privacidad en los siguientes enlaces:
                        </li>
                        <ul type="circle" className="mb-4">
                            <li>
                                LinkedIn:
                                <a className="mb-4 ms-2" target="_blank" rel="noreferrer"
                                    href="https://www.linkedin.com/legal/privacy-policy?trk=homepage-basic_footer-privacy-policy"
                                >
                                    https://www.linkedin.com/legal/privacy-policy?trk=homepage-basic_footer-privacy-policy
                                </a>
                            </li>
                            <li>
                                Instagram:
                                <a className="mb-4 ms-2" target="_blank" rel="noreferrer"
                                    href="https://help.instagram.com/519522125107875">
                                    https://help.instagram.com/519522125107875
                                </a>
                            </li>
                            <li>
                                Facebook:
                                <a className="mb-4 ms-2" target="_blank" rel="noreferrer"
                                    href="https://es-es.facebook.com/privacy/explanation">
                                    https://es-es.facebook.com/privacy/explanation
                                </a>
                            </li>
                        </ul>
                        <li>
                            <strong>Youtube:</strong>
                            Esta cookie está configurada por Youtube. Se utiliza para rastrear la
                            información de los videos incrustados de YouTube en un sitio web. Los
                            datos personales no se conservarán más allá del plazo necesario para
                            conseguir el fin para el cual se tratan, puede obtener más información
                            de la política de privacidad en
                            <a className="mb-4 ms-2" target="_blank" rel="noreferrer"
                                href="https://policies.google.com/privacy?hl=es&amp;gl=es">
                                https://policies.google.com/privacy?hl=es&amp;gl=es
                            </a>
                        </li>
                    </ul>
                    <p>
                        <strong></strong>
                    </p>
                    <p className="mb-4">
                        <strong>Cookies utilizadas por Solunion:</strong>
                    </p>
                    <p className="mb-4">
                        <strong>Cookies necesarias:</strong>
                    </p>

                    <table border="1" cellspacing="0" cellpadding="0" width="100%" style={{wordBreak: "break-word"}}>
                        <thead>
                            <tr>
                                <td width="30%" valign="top">
                                    <p>
                                        <strong>COOKIE</strong>
                                    </p>
                                </td>
                                <td width="20%" valign="top">
                                    <p>
                                        <strong>DURACIÓN</strong>
                                    </p>
                                </td>
                                <td width="50%" valign="top">
                                    <p>
                                        <strong>DESCRIPCIÓN</strong>
                                    </p>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td width="30%" valign="top">
                                    <p>
                                        <strong>cookielawinfo-checkbox-necessary</strong>
                                    </p>
                                </td>
                                <td width="20%" valign="top">
                                    <p>
                                        <strong>11 meses</strong>
                                    </p>
                                </td>
                                <td width="50%" valign="top">
                                    <p>
                                        <strong>
                                            Esta cookie está configurada por el complemento GDPR Cookie Consent.
                                            Las cookies se utilizan para almacenar el consentimiento del usuario
                                            para las cookies en la categoría "Necesario".
                                        </strong>
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td width="30%" valign="top">
                                    <p>
                                        <strong>cookielawinfo-checkbox-non-necessary</strong>
                                    </p>
                                </td>
                                <td width="20%" valign="top">
                                    <p>
                                        <strong>11 meses</strong>
                                    </p>
                                </td>
                                <td width="50%" valign="top">
                                    <p>
                                        <strong>Esta cookie se establece por el plugin de Consentimiento de Galletas GDPR.
                                            Las cookies se utilizan para almacenar el consentimiento del usuario
                                            para las cookies en la categoría "No necesario".</strong>
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td width="30%" valign="top">
                                    <p>
                                        <strong>viewed_cookie_policy</strong>
                                    </p>
                                </td>
                                <td width="20%" valign="top">
                                    <p>
                                        <strong>11 meses</strong>
                                    </p>
                                </td>
                                <td width="50%" valign="top">
                                    <p>
                                        <strong>
                                        La cookie se establece mediante el complemento de consentimiento de cookies GDPR
                                         y se utiliza para almacenar si el usuario ha consentido o no el uso de cookies. 
                                        No almacena ningún dato personal.
                                        </strong>
                                    </p>
                                </td>
                            </tr>
                        </tbody>
                    </table>


                    <p className="my-3">
                        <strong>Cookies de terceros:</strong>
                    </p>
                    <p className="my-3">
                        <strong>Google Analytics</strong>
                    </p>
                    <table border="1" cellspacing="0" cellpadding="0" width="100%">
                        <thead>
                            <tr>
                                <td width="30%" valign="top">
                                    <p>
                                        <strong>COOKIE</strong>
                                    </p>
                                </td>
                                <td width="20%" valign="top">
                                    <p>
                                        <strong>DURACIÓN</strong>
                                    </p>
                                </td>
                                <td width="50%" valign="top">
                                    <p>
                                        <strong>DESCRIPCIÓN</strong>
                                    </p>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td width="30%" valign="top">
                                    <p>
                                        <strong>_ga</strong>
                                    </p>
                                </td>
                                <td width="20%" valign="top">
                                    <p>
                                        <strong>2 años</strong>
                                    </p>
                                </td>
                                <td width="50%" valign="top">
                                    <p>
                                        <strong>
                                            Esta cookie es instalada por Google Analytics. La
                                            cookie se utiliza para calcular los datos de
                                            visitantes, sesiones, campañas y para hacer un
                                            seguimiento del uso del sitio para el informe analítico
                                            del mismo. Las cookies almacenan información de forma
                                            anónima y asignan un número generado aleatoriamente
                                            para identificar a los visitantes únicos.
                                        </strong>
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td width="30%" valign="top">
                                    <p>
                                        <strong>_gat_UA-96944408-2</strong>
                                    </p>
                                </td>
                                <td width="20%" valign="top">
                                    <p>
                                        <strong>1 minuto</strong>
                                    </p>
                                </td>
                                <td width="50%" valign="top">
                                    <p>
                                        <strong>Google Analytics</strong>
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td width="30%" valign="top">
                                    <p>
                                        <strong>_gid</strong>
                                    </p>
                                </td>
                                <td width="20%" valign="top">
                                    <p>
                                        <strong>1 día</strong>
                                    </p>
                                </td>
                                <td width="50%" valign="top">
                                    <p>
                                        <strong>
                                            Esta cookie es instalada por Google Analytics. La
                                            cookie se utiliza para almacenar información de cómo
                                            los visitantes utilizan un sitio web y ayuda en la
                                            creación de un informe analítico de cómo el sitio web
                                            está haciendo. Los datos recogidos incluyen el número
                                            de visitantes, la fuente de donde vienen y las páginas
                                            visitadas de forma anónima.
                                        </strong>
                                    </p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p>
                        <strong></strong>
                    </p>
                    <p>
                        <strong>Publicidad:</strong>
                        <strong></strong>
                    </p>
                    <table border="1" cellspacing="0" cellpadding="0" width="100%">
                        <thead>
                            <tr>
                                <td width="182" valign="top">
                                    <p>
                                        <strong>COOKIE</strong>
                                    </p>
                                </td>
                                <td width="182" valign="top">
                                    <p>
                                        <strong>DURACIÓN</strong>
                                    </p>
                                </td>
                                <td width="182" valign="top">
                                    <p>
                                        <strong>DESCRIPCIÓN</strong>
                                    </p>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td width="182" valign="top">
                                    <p>
                                        <strong>IDE</strong>
                                    </p>
                                </td>
                                <td width="182" valign="top">
                                    <p>
                                        <strong>2 años</strong>
                                    </p>
                                </td>
                                <td width="182" valign="top">
                                    <p>
                                        <strong>
                                            Utilizado por Google DoubleClick y almacena información
                                            sobre cómo el usuario usa el sitio web y cualquier otro
                                            anuncio antes de visitar el sitio web. Esto se utiliza
                                            para presentar a los usuarios anuncios que les sean
                                            relevantes según el perfil del usuario.
                                        </strong>
                                    </p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p>
                        <strong></strong>
                    </p>
                    <p>
                        <strong>Youtube:</strong>
                    </p>
                    <table border="1" cellspacing="0" cellpadding="0" width="100%" style={{wordBreak: "break-word"}}>
                        <thead>
                            <tr>
                                <td width="182" valign="top">
                                    <p>
                                        <strong>COOKIE</strong>
                                    </p>
                                </td>
                                <td width="182" valign="top">
                                    <p>
                                        <strong>DURACIÓN</strong>
                                    </p>
                                </td>
                                <td width="182" valign="top">
                                    <p>
                                        <strong>DESCRIPCIÓN</strong>
                                    </p>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td width="182" valign="top">
                                    <p>
                                        <strong>GPS</strong>
                                    </p>
                                </td>
                                <td width="182" valign="top">
                                    <p>
                                        <strong>30 minutos</strong>
                                    </p>
                                </td>
                                <td width="182" valign="top">
                                    <p>
                                        <strong>
                                            YouTube configura esta cookie y registra una
                                            identificación única para rastrear a los usuarios en
                                            función de su ubicación geográfica
                                        </strong>
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td width="182" valign="top">
                                    <p>
                                        <strong>VISITOR_INFO1_LIVE</strong>
                                    </p>
                                </td>
                                <td width="182" valign="top">
                                    <p>
                                        <strong>5 meses</strong>
                                    </p>
                                </td>
                                <td width="182" valign="top">
                                    <p>
                                        <strong>
                                            Esta cookie está configurada por Youtube. Se utiliza
                                            para rastrear la información de los videos incrustados
                                            de YouTube en un sitio web.
                                        </strong>
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td width="182" valign="top">
                                    <p>
                                        <strong>YSC</strong>
                                    </p>
                                </td>
                                <td width="182" valign="top">
                                    <p>
                                        <strong>Sesión</strong>
                                    </p>
                                </td>
                                <td width="182" valign="top">
                                    <p>
                                        <strong>
                                            YouTube configura estas cookies y se utiliza para
                                            rastrear las vistas de videos incrustados.
                                        </strong>
                                    </p>
                                </td>
                            </tr>
                            <tr>
                                <td width="182" valign="top">
                                    <p>
                                        <strong>YTC</strong>
                                    </p>
                                </td>
                                <td width="182" valign="top">
                                    <p>
                                        <strong>10 minutos</strong>
                                    </p>
                                </td>
                                <td width="182" valign="top">
                                    <p>
                                        <strong>Cookies de YouTube</strong>
                                    </p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p className="my-3">
                        <strong>Desactivación o eliminación de cookies</strong>
                    </p>
                    <p className="my-3">
                        En cualquier momento podrá ejercer su derecho de desactivación o
                        eliminación de cookies de nuestra web. Estas acciones se realizan de forma
                        diferente en función del navegador que esté usando.
                        <a className="mb-4 ms-2" target="_blank" rel="noreferrer"
                            href="https://solunion.com/mas-informacion-las-cookies/">
                            Aquí le dejamos una guía rápida para los navegadores más populares
                        </a>
                        .
                    </p>

                    <p className="my-3">
                        <strong>Notas adicionales</strong>
                    </p>
                    <ul type="disc" className="my-3">
                        <li>
                            Ni esta web ni sus representantes legales se hacen responsables ni del
                            contenido ni de la veracidad de las políticas de privacidad que puedan
                            tener los terceros mencionados en esta política de cookies.
                        </li>
                        <li>
                            Los navegadores web son las herramientas encargadas de almacenar las
                            cookies y desde este lugar debe efectuar su derecho a eliminación o
                            desactivación de las mismas. Ni esta web ni sus representantes legales
                            pueden garantizar la correcta o incorrecta manipulación de las cookies
                            por parte de los mencionados navegadores.
                        </li>
                        <li>
                            En algunos casos es necesario instalar cookies para que el navegador no
                            olvide su decisión de no aceptación de las mismas.
                        </li>
                        <li>
                            En el caso de las cookies de Google Analytics, esta empresa almacena
                            las cookies en servidores ubicados en Estados Unidos y se compromete a
                            no compartirla con terceros, excepto en los casos en los que sea
                            necesario para el funcionamiento del sistema o cuando la ley obligue a
                            tal efecto. Según Google no guarda su dirección IP. Google Inc. es una
                            compañía adherida al Acuerdo de Puerto Seguro que garantiza que todos
                            los datos transferidos serán tratados con un nivel de protección acorde
                            a la normativa europea. Puede consultar información detallada a este
                            respecto en este enlace. Si desea información sobre el uso que Google
                            da a las cookies le adjuntamos este otro enlace.
                        </li>
                        <li>
                            Para cualquier duda o consulta acerca de esta política de cookies no
                            dude en comunicarse con nosotros a través de la sección de contacto.
                        </li>
                    </ul>

                    <p className="my-3">
                        <strong>Cambios y actualizaciones en la Política de cookies</strong>
                    </p>
                    <p className="my-3">
                        Solunion y las empresas del Grupo pueden modificar esta Política de Cookies
                        en función de exigencias legislativas, reglamentarias, o con la finalidad
                        de adaptar dicha política a las instrucciones y recomendaciones dictadas
                        por los reguladores. Se recomienda, por tanto, revisar periódicamente la
                        Política de Cookies.
                    </p>
                </div>

            </div>


        </div>
    )
}